<template>
<a-modal
:maskClosable="false"
    :visible="visible"
    title="添加层级"
    :confirmLoading="confirmLoading"
    @ok="save"
    @cancel="cancel"
    destroyOnClose
  >
  <ak-type-input ref="addLevel" v-model="levelName" label="层级名称" type="String"  :validators="validators"/>
  </a-modal>
</template>
<script>
import { notEmpty } from '../../utils/validator.js'
import { createLevelTag } from '../../utils/level.js'
export default {
  props: {
    record: Object, // 当前行的数据
    vm: Object, // 触发这个action的组件对象，通常为modelTable或modelTree
    fields: Array, // 当前model的fields对象
    model: Object, // 当前model对象
    className: String, // 当前model的className
    modelName: String, // 当前model的名称
    category: String // 假如当前model显示为category格式，则会将当前的值传入
  },
  data () {
    return {
      confirmLoading: false,
      levelName: '',
      visible: true,
      validators: [ // 表单验证，与model中的validators用法一致
        notEmpty()
      ]
    }
  },
  methods: {
    async save () {
      const error = await this.$refs.addLevel.validate()
      if (error) { return }
      this.$loading.show()
      this.confirmLoading = true
      try {
        const res = await this.$tkParse.get('/classes/hierarchy', {
          params: {
            where: {
              parent: this.record.objectId
            },
            order: '-createdAt',
            limit: 1
          }
        })
        let tag
        if (res.data.results.length === 0) {
          tag = this.record.tag + '1-'
        } else {
          tag = createLevelTag(res.data.results[0].tag)
        }
        const data = {
          name: this.levelName,
          level: this.record.level + 1,
          tag: tag,
          parent: this.record.objectId
        }
        await this.$tkParse.post('/classes/hierarchy', data)
        this.vm.refresh()
        this.visible = false
        this.$notification['success']({
          message: '操作成功',
          description: '数据保存成功'
        })
        this.$emit('complete')
      } catch (e) {
        console.log(e)
        this.$notification['error']({
          message: '操作失败',
          description: '操作失败，请重试'
        })
      }
      this.confirmLoading = false
      this.$loading.hide()
    },
    cancel () {
      this.visible = false
    }
  }
}
</script>
<style>
</style>
